<template>
    <div id="main-container" class="px-0">
        <div class="scrollable-container" style="overflow-y: scroll;">
            <div class="button-container">
                <div class="d-flex align-items-center">
                    <font-awesome-icon icon="arrow-left" class="text-main" @click="goBack"
                        style="cursor: pointer; margin-top: 3px;" />
                    <span class="text-main font-weight-bold ml-2" @click="goBack" style="cursor: pointer;">{{ $t('Cancel')
                    }}</span>
                </div>
            </div>
            <div class="card card-container">
                <img id="img-card" class="img-card" src="@/assets/images/logo-login.png" />
                <h3 class="text-main font-weight-bold mt-3">{{ $t('Login') }}</h3>
                <Form @submit="handleLogin" :validation-schema="schema">
                    <div class="form-group">
                        <label for="email">{{ $t('Email Address') }}</label>
                        <Field name="email" type="email" class="form-control" />
                        <ErrorMessage name="email" class="error-feedback" />
                    </div>
                    <div class="form-group">
                        <label for="password">{{ $t('Password') }}</label>
                        <div class="input-group">
                            <Field name="password" type="password" class="form-control" />
                            <div class="input-group-prepend d-flex align-items-center pl-3">
                                <font-awesome-icon :icon="iconToggle" @click.prevent="togglePassword"
                                    style="cursor: pointer;" />
                            </div>
                        </div>
                        <ErrorMessage name="password" class="error-feedback" />
                    </div>
                    <div class="form-group pt-2">
                        <router-link to="/forgot-password" class="float-right text-main">
                            {{ $t('Forgot Your Password?') }}
                        </router-link>
                    </div>
                    <div class="form-group pt-3">
                        <button class="btn btn-main btn-block" :disabled="loading">
                            <span>{{ $t('Login') }}</span>
                        </button>
                    </div>
                    <div class="form-group pt-2">
                        <div class="d-flex justify-content-center">
                            <span class="text-center">
                                {{ $t('Don\'t have an account?') }}
                                <router-link to="/register" class="text-main">{{ $t('Register') }}</router-link>
                            </span>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";

export default {
    name: "LoginPage",
    components: {
        Form,
        Field,
        ErrorMessage,
    },
    data() {
        const schema = yup.object().shape({
            email: yup.string().required(this.$t("Data is required!", { data: this.$t("Email Address") })),
            password: yup.string().required("Data is required!", { data: this.$t("Password") }),
        });

        return {
            loading: false,
            schema,
            iconToggle: "eye",
        };
    },
    computed: {
        loggedIn() {
            return this.$store.state.auth.status.loggedIn;
        },
    },
    created() {
        if (this.loggedIn) {
            this.$router.push("/profile");
        }
        if (this.$route.query.isVerified) {
            this.$vueAlert.alert(this.$t("Your account has been verified. You can now login"), null, 'success');
        }
        if (this.$route.query.isReset) {
            this.$vueAlert.alert(this.$t("Your password has been reset. You can now login"), null, 'success');
        }
    },
    methods: {
        goBack() {
            this.$router.push("/");
        },
        togglePassword() {
            //element by name password
            var password = this.$el.querySelector("input[name='password']");
            if (password.type === "password") {
                password.focus();
                password.type = "text";
                this.iconToggle = "eye-slash";
            } else {
                password.focus();
                password.type = "password";
                this.iconToggle = "eye";
            }
        },
        handleLogin(user) {
            let loader = this.$loading.show();

            this.$store.dispatch("auth/login", user).then(
                (response) => {
                    if (response.data.user.email_verified_at) {
                        this.$router.push("/");
                    } else {
                        this.$router.push({
                            name: "Verify Email",
                            query: { userEmail: user.email }
                        });
                    }

                    loader.hide();
                },
                (error) => {
                    if (error.response && error.response.data && error.response.data.status === "unverified") {
                        this.$router.push({
                            name: "Verify Email",
                            query: { userEmail: user.email }
                        });
                    } else {
                        this.$vueAlert.alert((error.response && error.response.data && error.response.data.message) || error.message || error.toString(), null, 'error');
                    }
                    loader.hide();
                }
            );
        },
    },
};
</script>

<style scoped>
label {
    display: block;
    margin-top: 10px;
}

.button-container {
    max-width: 375px;
    margin: 0 auto 15px;
    margin-top: 50px;

    @media screen and (max-width: 600px) {
        margin-top: 25px;
        padding-left: 15px;
    }
}

.card-container.card {
    max-width: 375px !important;
    padding: 40px 40px;
}

.card {
    background-color: #fff;
    padding: 20px 25px 30px;
    margin: 0 auto 25px;
    /* margin-top: 50px; */
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.form-control {
    border-radius: 0;
    border-top: 0;
    border-left: 0;
    border-right: 0;
}
</style>
